export enum ITicketObjectType {
    Other = 0,
    WheelieBin = 1,
    UndergroundContainer = 2,
    Card = 3,
}
